import { authentication, errorLogging } from 'utils';
import axiosInstance from 'utils/axiosConfig';
import { envConfig} from "../config";

export const useCosmosService = () => {

    const config = envConfig();
    const serviceUrl = `${config.REACT_APP_COSMOS_ENDPOINT}`;
    const { handleHttpError } = errorLogging()

    const getDocuments = async (databaseName: string, containerName: string, query: string) => {
        let response = await axiosInstance
        .get(`${serviceUrl}/documents?databaseName=${databaseName}&containerName=${containerName}&query=${query}`,
            { headers: await authentication.getAuthHeader('application/json') })
            .catch(handleHttpError)

        const documents: any[] = response ? response.data : []

        return documents
    }

    const upsertDocuments = async (databaseName: string, containerName: string, items: any[]) => {
        const data = {
            PartitionKey: null,
            Items: items,
        }

        await axiosInstance
            .post(`${serviceUrl}/documents?databaseName=${databaseName}&containerName=${containerName}`, JSON.stringify(data), {
                headers: await authentication.getAuthHeader('application/json')
            }).catch(handleHttpError)
    }

    return {
        getDocuments: getDocuments,
        upsertDocuments: upsertDocuments
    }

}
